import React, { Component, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ProtvistaSequence from 'protvista-sequence';
import ProtvistaTrack from 'protvista-track';

window.customElements.define("protvista-track", ProtvistaTrack);

function SequenceFeatureViewer(props) {

    const { chainId, chainGcf, domainInfo, selectedResidues } = props;

    const [sequence, setSequence] = useState(null);

    const trackContainer = React.useRef(null);

    useEffect(() => {
        if (!chainGcf) {
            console.log("cannot render SequenceViewer without chainGcf");
            return;
        }
        console.log("getting atom sequence...")
        const seq = chainGcf.getAtomSequence();
        if (!seq) {
            console.log("failed to get Atom sequence from chaingcf")
            return;
        }
        console.log("atom sequence: ", seq)

        if (trackContainer) {
            console.log("trackContainer.current", trackContainer.current)
            trackContainer.current.sequence = seq;
            trackContainer.current.length = seq.length;
        }

        setSequence(sequence)
    }, [chainGcf]);

    return (
        <protvista-sequence ref={trackContainer} />
    );
}

SequenceFeatureViewer.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object,
}

export default SequenceFeatureViewer;